import React from "react"

const paymentProviderRef = React.createRef()

// List of words to cycle through
const paymentProviders = [
  "Paypal",
  "Mastercard",
  "Visa",
  "AliPay",
  "WeChat Pay",
  "many more..."
]

const Acceptance = () => {
  let currentMessage = 0

  // Map out each letter of each word
  const typeMessage = () => {
    if (!paymentProviders[currentMessage]) {
      currentMessage = 0
    }
    const currentStr = paymentProviders[currentMessage]
    currentStr.split()
    let part = ""
    let currentLetter = 0
    let int1 = setInterval(() => {
      if (!currentStr[currentLetter]) {
        currentMessage++
        setTimeout(() => {
          deleteMessage(part)
        }, 1000)
        clearInterval(int1)
      } else {
        part += currentStr[currentLetter++]
        paymentProviderRef.current.innerHTML = part
      }
    }, 100)
  }

  // Delete each letter after the word has been fully displayed
  const deleteMessage = str => {
    let int = setInterval(() => {
      if (str.length === 0) {
        setTimeout(() => {
          typeMessage()
        }, 1000)
        clearInterval(int)
      } else {
        str = str.split("")
        str.pop()
        str = str.join("")
        paymentProviderRef.current.innerHTML = str
      }
    }, 100)
  }

  // When component is rendered, run typewriter effect
  React.useEffect(() => {
    typeMessage()
  }, [])

  return (
    <div className="acceptance">
      <h1>
        <span>DigiWall accepts </span>
        <span>
          <span ref={paymentProviderRef} className="payment-provider" />
          <span className="cursor" />
        </span>
      </h1>
      <ul>
        <li>
          <img className="tick" src="/images/Homepage/tick.svg" alt="Tick" />
          <span>Single unified interface</span>
        </li>
        <li>
          <img className="tick" src="/images/Homepage/tick.svg" alt="Tick" />
          <span>Secure storage</span>
        </li>
        <li>
          <img className="tick" src="/images/Homepage/tick.svg" alt="Tick" />
          <span>Decentralised wallet</span>
        </li>
      </ul>
      <div className="acceptance-links">
        <img
          src="/images/Homepage/google-play.svg"
          alt="Google Play store link"
        />
        <img
          className="app-store"
          src="/images/Homepage/app-store.svg"
          alt="App store link"
        />
      </div>
    </div>
  )
}

export default Acceptance
